export enum TrialUserType {
    Investigators = 1,
    SiteTrialCoordinators = 2,
    MedicalReviewers = 3
}